import PageHero from '../components/PageHero';

const TYPES = [
  {icon:'💰',label:'Loan Guarantee Schemes',sub:'ऋण गारंटी योजनाएं'},
  {icon:'🏭',label:'Capital Subsidies',sub:'पूंजी सब्सिडी'},
  {icon:'📦',label:'Export Incentives',sub:'निर्यात प्रोत्साहन'},
  {icon:'🔬',label:'R&D and Technology Grants',sub:'अनुसंधान अनुदान'},
  {icon:'🌱',label:'Startup India Benefits',sub:'स्टार्टअप इंडिया'},
  {icon:'📊',label:'Sector-Specific Grants',sub:'क्षेत्र-विशिष्ट अनुदान'},
];

const SIZES = [
  {icon:'🏪',title:'Micro Enterprises',sub:'सूक्ष्म उद्यम',desc:'Under ₹1 crore investment'},
  {icon:'🏗️',title:'Small Businesses',sub:'लघु उद्योग',desc:'₹1–10 crore investment'},
  {icon:'🏢',title:'Medium Enterprises',sub:'मध्यम उद्यम',desc:'₹10–50 crore investment'},
  {icon:'🚀',title:'Startups',sub:'स्टार्टअप',desc:'DPIIT-recognized or eligible'},
];

export default function ForBusinesses({ go }) {
  return (
    <>
      <PageHero tag="For Businesses · व्यवसायों के लिए" title="Subsidies, Loans & Grants — Matched to Your Business" subtitle="सब्सिडी, ऋण, अनुदान — आपके व्यवसाय के लिए" from="#138808" to="#0A5C04" tagColor="rgba(255,255,255,.8)" />

      <section className="section section-gray">
        <div className="wrap">
          <div className="biz-top">
            <div>
              <p className="biz-desc">Enter your sector, size, and turnover once. We match you to MSME subsidies, startup schemes, sector grants, loan guarantees, and export incentives — all matched to your actual business profile, not a keyword search.</p>
              <ul className="checklist">
                {['Fill sector, size, and turnover once — no repeat entry','MSME, startup, and industry-specific schemes','Loan guarantees, subsidies, and export incentives','Manage documents and applications in one place','Central and state schemes both covered'].map(t=>(
                  <li key={t}><span className="tick" style={{color:'#138808'}}>✓</span>{t}</li>
                ))}
              </ul>
              <div className="biz-cta">
                <button className="btn btn-green" onClick={()=>go('contact')}>Find Schemes for My Business →</button>
              </div>
            </div>

            <div className="info-box">
              <div className="info-box-title" style={{color:'#138808'}}>Scheme Types for Businesses</div>
              {TYPES.map(u=>(
                <div key={u.label} className="info-row">
                  <span className="icon">{u.icon}</span>
                  <div><div className="label">{u.label}</div><div className="sub">{u.sub}</div></div>
                </div>
              ))}
            </div>
          </div>

          <div className="btype-header">
            <span className="tag" style={{color:'#138808'}}>
              <span className="tag-bar" style={{background:'#138808'}}/>
              Who We Serve · हम किसकी सेवा करते हैं
              <span className="tag-bar" style={{background:'#138808'}}/>
            </span>
          </div>

          <div className="btype-grid">
            {SIZES.map(bt=>(
              <div key={bt.title} className="btype-card">
                <div className="btype-icon">{bt.icon}</div>
                <h4>{bt.title}</h4>
                <div className="btype-sub">{bt.sub}</div>
                <p>{bt.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
